/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceLaneMonthRow
 */
export interface PerformanceLaneMonthRow {
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneMonthRow
   */
  month: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneMonthRow
   */
  quoted: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneMonthRow
   */
  won: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneMonthRow
   */
  winRate?: number;
}

/**
 * Check if a given object implements the PerformanceLaneMonthRow interface.
 */
export function instanceOfPerformanceLaneMonthRow(
  value: object,
): value is PerformanceLaneMonthRow {
  if (!("month" in value) || value["month"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("won" in value) || value["won"] === undefined) return false;
  return true;
}

export function PerformanceLaneMonthRowFromJSON(
  json: any,
): PerformanceLaneMonthRow {
  return PerformanceLaneMonthRowFromJSONTyped(json, false);
}

export function PerformanceLaneMonthRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceLaneMonthRow {
  if (json == null) {
    return json;
  }
  return {
    month: json["month"],
    quoted: json["quoted"],
    won: json["won"],
    winRate: json["winRate"] == null ? undefined : json["winRate"],
  };
}

export function PerformanceLaneMonthRowToJSON(
  json: any,
): PerformanceLaneMonthRow {
  return PerformanceLaneMonthRowToJSONTyped(json, false);
}

export function PerformanceLaneMonthRowToJSONTyped(
  value?: PerformanceLaneMonthRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    month: value["month"],
    quoted: value["quoted"],
    won: value["won"],
    winRate: value["winRate"],
  };
}
